import { render, staticRenderFns } from "./official-factor-filter.vue?vue&type=template&id=7f4b7d7f&"
import script from "./official-factor-filter.vue?vue&type=script&lang=js&"
export * from "./official-factor-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports